import React, { useState, useEffect } from "react";

const LoadingDots = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 4 ? prev + "." : "."));
    }, 500); // Change interval time as needed

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, []);

  return <span> {dots}</span>;
};

export default LoadingDots;
